import { IonCard } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import React from 'react';
import TextHelper from '../../utils/TextHelper';
import './Cards.scss';

export default function DecisionPointCard(props: { nodeDatum: any, gradient: string }) {
  const { nodeDatum, gradient } = props;

  return (
    <IonCard
      className="card-container"
      onClick={(
        () => document.getElementById(`onNodeClick-${nodeDatum.itemId}`)?.click()
      )}
    >
      <div style={{ background: `linear-gradient(90deg, ${gradient})`, height: '20px' }} />
      <div className="card-content-padding">
        <div className="card-title" style={{ height: '40px' }}>
          {TextHelper.stripHTML(nodeDatum?.name)}
        </div>
        {
          nodeDatum.description
            ? (
              <div className="card-description" style={{ height: '40px' }}>
                {`${TextHelper.stripHTML(nodeDatum?.description)?.substring(0, 44)}...`}
              </div>
            ) : null
        }
      </div>
    </IonCard>
  );
}
